import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import storage from 'good-storage'
import { Hub, ToastCeate } from 'common/js/hub'
import moment from 'moment'
import { getCommonData } from 'common/js/reqdata.js'
import { resCode, apiDomain, rootFile, getApiDomain } from 'api/config'
import { refershToken } from 'api/baseapi'
/* axios 配置 */
axios.defaults.baseURL = apiDomain
axios.defaults.data = getCommonData()
axios.defaults.timeout = 5000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8;'

let tokenFull = storage.get('token') || ''
function refshToken() {
  return new Promise((resolve, reject) => {
    refershToken().then(res => {
      if (res.code === resCode.ERR_OK) {
        tokenFull = res.resdata
        storage.set('token', res.resdata)
        axios.defaults.data = getCommonData()
        resolve(res.resdata)
      }
      toastHide()
    })
  })
}
const getToakenAsync = async function (config) {
  let result = await refshToken()
  config.data.accesstoken = result.accessToken
  return config
}

function ceateToast(title, icon, time) {
  Hub.mainToast.remove()
  Hub.mainToast = ToastCeate(title, icon, time)
}

function toastShow() {
  Hub.mainToast.show()
  Hub.isToastShow = true
}

function toastHide() {
  Hub.mainToast.hide()
  Hub.isToastShow = false
  Hub.mainToast.remove()
}

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  toastHide()
  if (response.data.code === resCode.ERR_EX) {
    refshToken().then(res => {
      if (res) {
        location.href = `${location.href}?id=${Math.random()}`
      }
    })
  } else if (response.data.code === resCode.ERR_OR || response.data.code === resCode.ERR_RF || response.data.code === resCode.ERR_RT) {
    storage.remove('token')
    storage.remove('user')
    Vue.prototype.Hub.user = ''
    location.href = `${rootFile}home`
  } else if (response.data.code === resCode.ERR_NR) {
    ceateToast('现处于内测阶段，暂不对外开放。', 'warn', 1000)
    Hub.mainToast.show()
  } else if (response.data.code !== resCode.ERR_OK) {
    // ceateToast(response.data.msg, 'error', 1000)
    // Hub.mainToast.show()
  }
  // response.data.code === resCode.ERR_DS //判断手机号被禁用
  // response.data.code === resCode.ERR_XS //系统错误
  return response
}, function (error) {
  ceateToast('网络错误', 'error', 1000)
  Hub.mainToast.show()
  return Promise.reject(error)
})

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  setBaseUrl(config)
  if (!Hub.isToastShow) {
    ceateToast('', 'loading', 0)
    toastShow()
  }
  if (!config.url.match(/public/) && tokenFull) {
    const nowDate = moment()
    const endDate = moment(tokenFull.accessTokenCreateTimesTamp).add(tokenFull.accessTokenExpirein, 's')
    const isRefresh = endDate.isBefore(nowDate)
    if (isRefresh) {
      return getToakenAsync(config)
    } else {
      return config
    }
  } else {
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

/**
 * 设置接口地址
 * @param {*} config 
 */
function setBaseUrl(config) {
  let from = filterRequestUrl(config.url);
  let apiDomain = getApiDomain(config.url, from)
  config.baseURL = apiDomain
}

/**
 * 如果地址在数组中存在
 * @param {*} url 
 */
function filterRequestUrl(url) {
  let from = ''
  let pmiArr = []
  var pmiIndex = pmiArr.findIndex(function (item) {
    return url.indexOf(item) >= 0;
  });
  if (pmiIndex >= 0) {
    from = 'pmi'
  }
  return from
}

Vue.use(VueAxios, axios)
/* axios 配置end */



// WEBPACK FOOTER //
// ./src/common/js/axiosset.js